"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const browser_tracker_1 = require("@snowplow/browser-tracker");
const windowListener_1 = require("../../utils/windowListener");
/**
 * Sends the page_view event and refreshes link tracking
 *
 * @param pageViewContexts - optional array of contexts that may be appended to the page_view event
 */
const enhancedPageView = (pageViewContexts) => {
    (0, browser_tracker_1.trackPageView)({ context: pageViewContexts });
    (0, windowListener_1.dispatchPageViewReadyEvent)();
};
exports.default = enhancedPageView;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvdXRpbHMvZW5oYW5jZWRQYWdlVmlldy9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLCtEQUEwRDtBQUUxRCwrREFBd0U7QUFFeEU7Ozs7R0FJRztBQUNILE1BQU0sZ0JBQWdCLEdBQUcsQ0FBQyxnQkFBdUMsRUFBUSxFQUFFO0lBQ3ZFLElBQUEsK0JBQWEsRUFBQyxFQUFFLE9BQU8sRUFBRSxnQkFBZ0IsRUFBRSxDQUFDLENBQUM7SUFFN0MsSUFBQSwyQ0FBMEIsR0FBRSxDQUFDO0FBQ2pDLENBQUMsQ0FBQztBQUVGLGtCQUFlLGdCQUFnQixDQUFDIn0=


// WEBPACK FOOTER //
// ../../../../src/utils/enhancedPageView/index.ts